import { useLocation } from 'react-router-dom';

import useQueryParams from '../useQueryParams';

/**
 * Determines whether the "headerVariant" query parameter is set to enable
 * a focused header variant. This setting is utilized by ReChat through
 * the widget integration.
 * Related task: https://skyslope.atlassian.net/browse/AP-772
 */

export function useHeaderVariant() {
  const { pathname } = useLocation();
  const isViewingFile = pathname.includes('/file-details/');
  const headerVariant = useQueryParams().get('headerVariant');

  const storedHeaderVariant = sessionStorage.getItem('headerVariant');

  if (headerVariant === 'focused' || storedHeaderVariant === 'focused') {
    if (headerVariant === 'focused') {
      sessionStorage.setItem('headerVariant', headerVariant);
    }

    return { variant: 'focused', useDefaultHeader: !isViewingFile };
  }

  return { variant: 'default', useDefaultHeader: true };
}
